import React from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import { api } from "../../helper/api.interceptor";

function DeleteBannerButton({ bannerId, onDeleteSuccess }) {
    const handleDelete = async () => {
        const confirmDelete = await Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the banner.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (confirmDelete.isConfirmed) {
            try {
                const response = await api.removeSolarInfoBanner(bannerId);

                if (response.status_code === 200) {
                    Swal.fire("Deleted!", "The banner has been removed.", "success");
                    if (onDeleteSuccess) onDeleteSuccess(bannerId); // Call parent callback
                } else {
                    Swal.fire("Error", response.message || "Failed to delete banner.", "error");
                }
            } catch (err) {
                console.error("Error deleting banner:", err);
                Swal.fire("Error", "Server error. Please try again later.", "error");
            }
        }
    };

    return (
        <button
            className="btn btn-sm btn-outline-danger rounded-circle"
            onClick={handleDelete}
        >
            <Icon icon="mdi:delete-outline" className="fs-5" />
        </button>
    );
}

export default DeleteBannerButton;
